import { render, staticRenderFns } from "./setSignature.vue?vue&type=template&id=7ad5ce3a&scoped=true&"
import script from "./setSignature.vue?vue&type=script&lang=js&"
export * from "./setSignature.vue?vue&type=script&lang=js&"
import style0 from "./setSignature.vue?vue&type=style&index=0&id=7ad5ce3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad5ce3a",
  null
  
)

export default component.exports